import { render, staticRenderFns } from "./Nvai.vue?vue&type=template&id=d01ca300&scoped=true&"
import script from "./Nvai.vue?vue&type=script&lang=js&"
export * from "./Nvai.vue?vue&type=script&lang=js&"
import style0 from "./Nvai.vue?vue&type=style&index=0&id=d01ca300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01ca300",
  null
  
)

export default component.exports